<template>
  <div class="container-fluid">
    <br />
    <b-row v-if="!loadingData">
      <b-col sm="12">
        <b-card>
          <b-row>
            <b-col sm="3">
              <p>Fontes:</p>
            </b-col>
            <b-col sm="2" class="text-right">
              <b-form-select id="basicSelectLg"
                v-model="sourceType"
                size="lg"
                :plain="true"
                :options="[{value: 0, text: 'Genérico'},{value: 1, text: 'Nutrição'}, {value: 2, text: 'Educação Física'}]"
                value="Please select">
              </b-form-select>
            </b-col>
            <b-col sm="5" class="text-right">
              <input
                class="form-control"
                type="text"
                placeholder="Link da Fonte"
                v-model="sourceDescription"
              />
            </b-col>
            <b-col sm="2" class="text-right">
              <b-button variant="primary" @click="registerSource">Registrar Fonte</b-button>
            </b-col>
          </b-row>
          <ul class="list-group" v-if="sources">
            <div v-for="(source, index) in sources" :key="index">
              <li class="list-group-item" v-if="!source.automatic"><b-badge variant="success" v-if="source.type == 0 || source.type == 1">Nutrição</b-badge><b-badge variant="primary" v-if="source.type == 0 || source.type == 2">Educação Física</b-badge>  - <a target="_blank" :href="source.description">{{source.description}}</a></li>
            </div>
          </ul>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: "ResellerManage",
  data: () => {
    return {
      loadingData: false,
      whitelabel: undefined,
      type: undefined,
      sources: [],
      sourceDescription: "",
      sourceType: 0
    };
  },
  methods: {
    registerSource: function () {
      this.loadingData = true;
      service.registerSource(this.sourceDescription, this.sourceType).then((response) => {
        if (response && response.sources) {
          this.loadingData = false;
          this.sources = response.sources;
          this.sourceDescription = "";
          this.sourceType = 0;
        }
      });
    }
  },
  components: { Spinner },
  created() {
    this.loadingData = true;
    service.getSources().then((response) => {
      if (response && response.sources) {
        this.loadingData = false;
        this.sources = response.sources;
      }
    });
  }, 
  computed: {
    isAdmin: function() {
      return localStorage.admin;
    },
  }
};
</script>


